import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ProgramService } from '../services/program.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LimitedMenuGuard implements CanActivate {
  constructor(private programService: ProgramService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.programService.programId$.pipe(
      map(programId => {
        if (programId === 0) {
          return true;
        } else {
          return this.router.createUrlTree(['/']);
        }
      })
    );
  }
} 